import React from 'react';
import { VDS_SETTING_ROWS } from '../../constants/latest-asset-trend.constant';
import GenericEspWidget from './GenericEspWidget';

const VdsSettingsProtectionWidget: React.FC = () => (
  <GenericEspWidget title='VSD settings & protection' rowsConfig={VDS_SETTING_ROWS} />
);

export default VdsSettingsProtectionWidget;
